import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { optionsLang } from 'data';
import { changeSettings } from 'redux/auth/authOperations';
import { setLanguageLocal } from 'redux/auth/authSlice';
import {
  selectIsLoggedIn,
  selectUserLanguage,
  selectUserSettings,
} from 'redux/selectors';
import { applyAppLanguage, normalizeLanguageCode } from 'utils/language';

export function useLanguageSwitcher() {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const settings = useSelector(selectUserSettings);
  const lang = useSelector(selectUserLanguage);
  const normalizedLang = normalizeLanguageCode(lang);

  const [language, setLanguage] = useState(
    () => optionsLang.find(el => el.value === normalizedLang) || optionsLang[0]
  );

  useEffect(() => {
    const option =
      optionsLang.find(el => el.value === normalizeLanguageCode(lang)) ||
      optionsLang[0];
    setLanguage(option);
  }, [lang]);

  const updateLanguage = useCallback(
    value => {
      const option =
        typeof value === 'string'
          ? optionsLang.find(el => el.value === normalizeLanguageCode(value)) ||
            optionsLang[0]
          : value;

      applyAppLanguage(option.value, {
        dispatch,
        setLanguageLocal,
        isLoggedIn,
        settings,
        changeSettings: isLoggedIn ? changeSettings : null,
      });
      setLanguage(option);
    },
    [dispatch, isLoggedIn, settings]
  );

  const setLanguageByCode = useCallback(
    code => updateLanguage(code),
    [updateLanguage]
  );

  return {
    language,
    activeCode: normalizedLang,
    setLanguageByCode,
    updateLanguage,
    options: optionsLang,
  };
}
